//並び替え・絞り込み時の処理（リロード）
//let lastUrl = new URL(window.location.href);

//const observer = new MutationObserver(() => {
//    const currentUrl = new URL(window.location.href);
//    const isWideScreen = window.innerWidth >= 750;

//    if (currentUrl.search !== lastUrl.search) {
//        if (isWideScreen || currentUrl.searchParams.has("sort_by")) {
//            location.reload();
//        }
//        lastUrl = currentUrl;
//    }
//});

//observer.observe(document, { subtree: true, childList: true });


//並び替え・絞り込み時の処理（リロード）部分の軽量化に伴う書き換え
function reinitializeProductGrid() {
  // LazyLoad（もし使っていれば再初期化）
  if (typeof LazyLoad !== "undefined") {
    new LazyLoad({
      elements_selector: ".lazyload"
    });
  }

  // data-src を src に移して画像を表示（画像が表示されない対策）
  document.querySelectorAll('img[data-src]').forEach(img => {
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
  });

  // AOS（アニメーションライブラリ）を使用している場合は再初期化
  if (typeof AOS !== "undefined") {
    AOS.refreshHard();
  }
}


// スマホ表示時に絞り込みサイドバーを畳んだ時の処理
document.addEventListener('DOMContentLoaded', () => {
  // 動的に追加されたリンク要素を監視してイベントリスナーを追加
  const observeDynamicLinks = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const link = node.querySelector('.collection__sidebar__close');
            if (link) {
              addReloadListener(link);
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  // ページリロードイベントリスナーを追加する関数
  const addReloadListener = (link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault(); // デフォルト動作を防ぐ
      event.stopPropagation(); // イベントのバブリングを防ぐ
      location.reload(); // ページをリロード
    });
  };

  // 既存のリンク要素にイベントリスナーを追加
  const existingLink = document.querySelector('.collection__sidebar__close');
  if (existingLink) {
    addReloadListener(existingLink);
  }

  // 動的に追加されるリンク要素を監視
  observeDynamicLinks();

  // .collection__sidebar__sliderがvisibility: visibleの場合のクリック外判定
  const sidebarSlider = document.querySelector('.collection__sidebar__slider');
  if (sidebarSlider) {
    document.addEventListener('click', (event) => {
      const isVisible = getComputedStyle(sidebarSlider).visibility === 'visible';
      const isWideScreen = window.innerWidth >= 750; // 画面幅が750px以上かどうかを判定

      if (!isWideScreen && isVisible && !sidebarSlider.contains(event.target)) {
        location.reload(); // ページをリロード
      }
    });
  }
});


// ブランドボタンの表示処理
document.addEventListener("DOMContentLoaded", () => {
  const currentURL = decodeURIComponent(window.location.href); // デコードして取得
  const queryString = currentURL.split("?")[1]; // ? 以降の文字列を取得

  if (!queryString) return; // ? 以降がない場合は処理終了

  document.querySelectorAll("ul.collection-nav-brand li a").forEach(a => {
      const hrefQuery = a.getAttribute("href")?.replace(/^\?/, ""); // 先頭の ? を削除
      if (!hrefQuery) return;

      const decodedHrefQuery = decodeURIComponent(hrefQuery); // デコード処理

      if (queryString.includes(decodedHrefQuery)) {
          a.classList.add("active");
      } else {
          a.classList.remove("active");
      }
  });
});
